import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import classNames from 'classnames';

import Modal from '@material-ui/core/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';

import LoadingBar from 'react-redux-loading-bar';
import NextIcon from '@material-ui/icons/NavigateNext';
import DoneIcon from '@material-ui/icons/CheckCircle';
import SpeakerNotes from '@material-ui/icons/SpeakerNotes';
import SpeakerNotesOff from '@material-ui/icons/SpeakerNotesOff';
import { withCookies, Cookies } from 'react-cookie';
import { createEditorState } from 'medium-draft';

import Snackbar from '@material-ui/core/Snackbar';
import Link from '../../components/Link';
import Intercom from '../../widgets/Intercom';

import CongratulationsModal from './CongratulationsModal/CongratulationsModal';
import SkillEvaluationModal from './SkillEvaluationModal/SkillEvaluationModal';
import LessonReviewModal from './LessonReviewModal/LessonReviewModal';
import LessonHeader from './LessonHeader/LessonHeader';
import Audio from './Audio/Audio';
import Text from './Text/Text';
import Video from './Video/Video';
import { userRole } from '../../constants';

import s from './LessonDetails.scss';

import {
  // buildQuery,
  hasMedicalLicense,
  getImagesFromDraftJS,
  isTrial,
} from '../../helpers';
import isMobileUserAgent from '../../helpers/checkMobileUserAgent';
import isLoggedIn from '../../helpers/checkAuth';

import * as lessonDetailsActions from '../../actions/lessonDetails';
import * as courseDetailsActions from '../../actions/courseDetails';
import { getCourseReview } from '../../actions/courseReview';

import messages from './lessonDetailsMessages';
import decorators from './Text/decorators';

@injectIntl
@withCookies
@withStyles(s)
@connect(
  state => ({
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    textNotes: state.lessonDetails.textNotes,
    loadingTextNotes: state.lessonDetails.loadingTextNotes,
    isPlayerLoaded: state.lessonDetails.isPlayerLoaded,
    isNotesShown: state.lessonDetails.isNotesShown,
    videoNotes: state.lessonDetails.videoNotes,
    completed: state.lessonDetails.completed,
    course: state.courseDetails.course,
    transcodingJobs: state.transcodingJobs.jobs,
    totalTranscodingJobs: state.transcodingJobs.total,
    lang: state.intl.locale,
    completeLessonError: state.lessonDetails.error,
  }),
  dispatch =>
    bindActionCreators(
      {
        getLessonTextNotes: lessonDetailsActions.getLessonTextNotes,
        updateState: lessonDetailsActions.updateState,
        completeLesson: lessonDetailsActions.completeLesson,
        resetCompletedLesson: lessonDetailsActions.resetCompletedLesson,
        getCourseBySlug: courseDetailsActions.getCourseBySlug,
        resetVideoNotes: lessonDetailsActions.resetVideoNotes,
        resetTextNotes: lessonDetailsActions.resetTextNotes,
        getCourseReview,
      },
      dispatch,
    ),
)
export default class LessonDetails extends React.Component {
  static propTypes = {
    auth: PropTypes.object,  // eslint-disable-line
    lesson: PropTypes.object.isRequired,  // eslint-disable-line
    course: PropTypes.object.isRequired,  // eslint-disable-line
    textNotes: PropTypes.array.isRequired,  // eslint-disable-line
    videoNotes: PropTypes.array.isRequired,  // eslint-disable-line
    cookies: PropTypes.instanceOf(Cookies).isRequired,
    courseSlug: PropTypes.string,
    getLessonTextNotes: PropTypes.func.isRequired,
    updateState: PropTypes.func.isRequired,
    loadingTextNotes: PropTypes.bool.isRequired,
    query: PropTypes.object, // eslint-disable-line
    transcodingJobs: PropTypes.array.isRequired,  // eslint-disable-line
    totalTranscodingJobs: PropTypes.number.isRequired,
    intl: intlShape.isRequired,
    lang: PropTypes.string.isRequired,
    completeLesson: PropTypes.func.isRequired,
    completed: PropTypes.bool.isRequired,
    getCourseBySlug: PropTypes.func.isRequired,
    resetTextNotes: PropTypes.func.isRequired,
    getCourseReview: PropTypes.func.isRequired,
    resetVideoNotes: PropTypes.func.isRequired,
    isNotesShown: PropTypes.bool.isRequired,
    updatingTextNotes: PropTypes.bool.isRequired,
    isIOS: PropTypes.bool.isRequired,
    posterVimeo: PropTypes.string,
    completeLessonError: PropTypes.shape({}),
    resetCompletedLesson: PropTypes.func.isRequired,
    searchSessionId: PropTypes.string,
  };

  static defaultProps = {
    query: {},
    courseSlug: undefined,
    posterVimeo: '',
    completeLessonError: null,
    searchSessionId: '',
  };

  static contextTypes = {
    fetch: PropTypes.func,
    organizationSlug: PropTypes.string,
    whitelabeling: PropTypes.shape({}),
  };

  constructor(props) {
    super(props);
    this.completeOnce = _.once(this.complete);
    const { course, query } = props;

    const lessonsAndQuizzes = _((course && course.sections) || [])
      .map('items')
      .flatten()
      .value();

    const lessonIndex = _.findIndex(
      lessonsAndQuizzes,
      item => item.item._id === _.get(this, 'props.lesson._id'),
    );

    const nextItem = lessonsAndQuizzes[lessonIndex + 1];

    this.state = {
      isCongratulationsModalOpened: false,
      showLessonReviewModal: false,
      isAudioEnded: false,
      errorSnackbarMsg: '',
      isEvaluationModalOpened:
        _.has(query, 'showEvaluationModal') &&
        _.get(props, 'auth.user.role') !== userRole.ADMIN,
      nextItem,
      nextUrl:
        nextItem &&
        (nextItem.itemType === 'Lesson'
          ? `lessons/${nextItem.item.slug}`
          : `quizzes/${nextItem.item._id}`),
    };

    const contentTypeSwitchers = _.assign(
      { video: true, audio: false, text: true },
      this.props.cookies.get('contentTypeSwitchers'),
    );

    if (
      !_.get(props, 'lesson.videos.length') &&
      !_.get(props, 'totalTranscodingJobs') &&
      !_.get(props, 'lesson.youtubeVideoUrl')
    ) {
      contentTypeSwitchers.video = false;
      contentTypeSwitchers.text = true;
      contentTypeSwitchers.audio = true;
    }

    if (!_.get(props, 'lesson.audios.length')) {
      contentTypeSwitchers.audio = false;
    }

    if (
      _.get(props, 'lesson.audios.length') ||
      _.get(props, 'lesson.youtubeVideoUrl') ||
      _.get(props, 'lesson.videos.length')
    ) {
      const editorState = createEditorState(
        _.get(props, 'lesson.content'),
        decorators,
      );
      const editorStateContent = editorState && editorState.getCurrentContent();
      const imageContent = getImagesFromDraftJS(_.get(props, 'lesson.content'));

      const isTextExist =
        (editorStateContent &&
          editorStateContent.hasText() &&
          !!editorStateContent.getPlainText().trim().length) ||
        !!_.get(imageContent, 'length');

      if (!isTextExist) {
        this.state.isTextContentSwitcherDisabled = true;
        if (!contentTypeSwitchers.audio) {
          contentTypeSwitchers.text = false;
        }
      }
    }

    this.state.contentTypeSwitchers = contentTypeSwitchers;
    this.state.videoFullPage =
      this.props.isIOS ||
      this.props.lesson.youtubeVideoUrl ||
      (this.props.totalTranscodingJobs &&
        !_.get(this.props.lesson, 'videos.length'))
        ? false
        : !this.props.cookies.get('contentTypeSwitchers') &&
          contentTypeSwitchers.video;
  }

  componentDidMount() {
    if (!this.state.videoFullPage && !isMobileUserAgent()) {
      Intercom.boot(this.props.auth.user, this.context.whitelabeling);
    } else {
      Intercom.hideWidget();
    }
    this.updateNavBar();
    if (_.get(this, 'props.course._id') && isLoggedIn(this.props.auth)) {
      this.props.getCourseReview(_.get(this, 'props.course._id'));
    }
    window.addEventListener('resize', this.updateNavBar);
    window.addEventListener('afterprint', this.afterPrint);
    window.addEventListener('beforeprint', this.beforePrint);
    this.logSearchSessionLessonOpened();
  }

  componentWillReceiveProps(nextProps) {
    if (_.get(this, 'props.lesson._id') !== _.get(nextProps, 'lesson._id')) {
      this.completeOnce = _.once(this.complete);
      // eslint-disable-next-line react/no-unused-class-component-methods
      this.playFrom = 0;

      const lessonsAndQuizzes = _(_.get(nextProps, 'course.sections', []))
        .map('items')
        .flatten()
        .value();

      const lessonIndex = _.findIndex(
        lessonsAndQuizzes,
        item => item.item._id === _.get(nextProps, 'lesson._id'),
      );

      const nextItem = lessonsAndQuizzes[lessonIndex + 1];

      const nextUrl =
        nextItem &&
        (nextItem.itemType === 'Lesson'
          ? `lessons/${nextItem.item.slug}`
          : `quizzes/${nextItem.item._id}`);

      const contentTypeSwitchers = _.assign(
        { video: true, audio: false, text: true },
        nextProps.cookies.get('contentTypeSwitchers'),
      );

      if (
        !_.get(nextProps, 'lesson.videos.length') &&
        !_.get(nextProps, 'totalTranscodingJobs') &&
        !_.get(nextProps, 'lesson.youtubeVideoUrl')
      ) {
        contentTypeSwitchers.video = false;
        contentTypeSwitchers.text = true;
        contentTypeSwitchers.audio = true;
      }

      if (!_.get(nextProps, 'lesson.audios.length')) {
        contentTypeSwitchers.audio = false;
      }

      let isTextContentSwitcherDisabled = false;
      if (
        _.get(nextProps, 'lesson.audios.length') ||
        _.get(nextProps, 'lesson.youtubeVideoUrl') ||
        _.get(nextProps, 'lesson.videos.length')
      ) {
        const editorState = createEditorState(
          _.get(nextProps, 'lesson.content'),
          decorators,
        );
        const editorStateContent =
          editorState && editorState.getCurrentContent();
        const imageContent = getImagesFromDraftJS(
          _.get(nextProps, 'lesson.content'),
        );

        const isTextExist =
          (editorStateContent &&
            editorStateContent.hasText() &&
            !!editorStateContent.getPlainText().trim().length) ||
          !!_.get(imageContent, 'length');

        if (!isTextExist) {
          isTextContentSwitcherDisabled = true;
          if (!contentTypeSwitchers.audio) {
            contentTypeSwitchers.text = false;
          }
        }
      }

      this.setState({
        isTextContentSwitcherDisabled,
        videoFullPage: false,
        showLessonReviewModal: false,
        isAudioEnded: false,
        nextItem,
        nextUrl,
        contentTypeSwitchers,
      });
    }

    if (
      _.get(this, 'props.course._id') === _.get(nextProps, 'course._id') &&
      (_.get(this, 'props.course.progress') !== 100 &&
        _.get(nextProps, 'course.progress')) === 100
    ) {
      this.setState({ isCongratulationsModalOpened: true });
      _.invoke(this.player, 'pause');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.completeLessonError &&
      _.get(this.props, 'completeLessonError.message') !==
        _.get(prevProps, 'completeLessonError.message')
    ) {
      this.closeCompletedLessonModal();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateNavBar);
    window.removeEventListener('afterprint', this.afterPrint);
    window.removeEventListener('beforeprint', this.beforePrint);
    this.props.resetVideoNotes();
    this.props.resetTextNotes();
  }

  setAudioEnded = isAudioEnded => {
    this.setState({ isAudioEnded });
  };

  afterPrint = () => {
    this.setState({
      contentTypeSwitchers: { ...this.oldContentTypeSwitchers },
    });
  };

  beforePrint = () => {
    const { contentTypeSwitchers } = this.state;

    this.oldContentTypeSwitchers = { ...contentTypeSwitchers };

    if (!contentTypeSwitchers.text) {
      contentTypeSwitchers.text = true;

      this.setState({
        contentTypeSwitchers,
      });
    }
  };

  updateNavBar = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  handleChangeVideoFullPage = (videoFullPage, cb = () => null) =>
    this.setState({ videoFullPage }, cb);

  toggleNotes = () => {
    const { isNotesShown, updateState } = this.props;

    if (this.updateTextNotes) {
      this.updateTextNotes(!isNotesShown);
    }

    if (this.updateVideoNotes) {
      this.updateVideoNotes(!isNotesShown);
    }

    updateState('isNotesShown', !isNotesShown);
  };

  switchContentType = type => {
    const { contentTypeSwitchers, isTextContentSwitcherDisabled } = this.state;
    const { lesson, cookies } = this.props;
    const newTypeState = !contentTypeSwitchers[type];
    //
    // if (type === 'audio' && !_.get(lesson, 'videos.length')) {
    //   return;
    // }

    if (type === 'text' && contentTypeSwitchers.audio) {
      return;
    }

    const newContentTypeSwitchers = {
      ...contentTypeSwitchers,
      [type]: newTypeState,
    };

    if (
      type === 'video' &&
      !contentTypeSwitchers.text &&
      contentTypeSwitchers.video
    ) {
      return;
    }

    if (
      type === 'video' &&
      !_.get(lesson, 'audios.length') &&
      contentTypeSwitchers.video
    ) {
      newContentTypeSwitchers.text = true;
    }

    if (type === 'video') {
      newContentTypeSwitchers.audio =
        !newTypeState && !!_.get(lesson, 'audios.length');
      newContentTypeSwitchers.text = true;
    }

    if (type === 'audio') {
      newContentTypeSwitchers.video =
        !newTypeState && !!_.get(lesson, 'videos.length');
      newContentTypeSwitchers.text = true;
    }

    if (isTextContentSwitcherDisabled && !newContentTypeSwitchers.audio) {
      newContentTypeSwitchers.text = false;
    }

    if (
      !newContentTypeSwitchers.audio &&
      !newContentTypeSwitchers.text &&
      !newContentTypeSwitchers.video &&
      isTextContentSwitcherDisabled &&
      contentTypeSwitchers.audio
    ) {
      return;
    }

    if (
      !newContentTypeSwitchers.audio &&
      !newContentTypeSwitchers.text &&
      !newContentTypeSwitchers.video
    ) {
      newContentTypeSwitchers.text = true;
    }

    const newState = {
      contentTypeSwitchers: newContentTypeSwitchers,
    };

    if (
      contentTypeSwitchers.video &&
      !newContentTypeSwitchers.video &&
      this.player
    ) {
      newState.playFrom = this.player.currentTime();
    }

    this.setState(newState, () => {
      if (_.get(this, 'player.resizeVideoJS')) {
        this.player.resizeVideoJS();
      }

      if (
        !contentTypeSwitchers.video &&
        newContentTypeSwitchers.video &&
        this.player &&
        newState.playFrom
      ) {
        this.player.currentTime(newState.playFrom);
      }
    });

    cookies.set('contentTypeSwitchers', newContentTypeSwitchers, {
      path: '/',
      domain: window.App.cookieDomain,
    });
  };

  complete = () => {
    const {
      lesson: { _id: lessonId },
      course: { _id: courseId, slug: courseSlug },
      completeLesson,
      getCourseBySlug,
      auth,
    } = this.props;

    if (!courseId || !isLoggedIn(auth)) {
      return true;
    }

    return completeLesson({ lessonId, courseId, courseSlug }).then(() => {
      getCourseBySlug(courseSlug);
    });
  };

  closeCongratulationsModal = () => {
    this.setState({
      isCongratulationsModalOpened: false,
    });
  };

  closeEvaluationModal = () => {
    this.setState({
      isEvaluationModalOpened: false,
    });
  };

  toggleLessonReviewContent = showLessonReviewModal => {
    this.setState({ showLessonReviewModal });
  };

  closeCompletedLessonModal = () => {
    const { completeLessonError, resetCompletedLesson } = this.props;

    this.setState({
      errorSnackbarMsg: _.get(completeLessonError, 'message', ''),
    });
    resetCompletedLesson();
  };

  handleCloseErrorSnackbar = () => {
    this.setState({ errorSnackbarMsg: '' });
  };

  logSearchSessionLessonOpened = async () => {
    const { lesson, searchSessionId, auth } = this.props;
    if (!searchSessionId || !isLoggedIn(auth)) {
      return;
    }
    try {
      await this.context.fetch(
        `/api/courses/search-session/${searchSessionId}/log-item`,
        {
          method: 'PATCH',
          body: JSON.stringify({
            lessonIdOpenedBySearch: lesson?._id,
          }),
        },
      );
    } catch (err) {
      console.error(err);
    }
  };

  render() {
    const {
      auth,
      lesson,
      course,
      loadingTextNotes,
      updatingTextNotes,
      isNotesShown,
      query,
      totalTranscodingJobs,
      intl: { formatMessage },
      posterVimeo,
    } = this.props;
    const { completed } = this.props;

    const {
      contentTypeSwitchers,
      videoFullPage,
      nextItem,
      nextUrl,
      isCongratulationsModalOpened,
      isEvaluationModalOpened,
      playFrom,
      showLessonReviewModal,
      isAudioEnded,
      isTextContentSwitcherDisabled,
      errorSnackbarMsg,
    } = this.state;

    const noNotesYet =
      !_.get(this, 'props.textNotes.length') &&
      !_.get(this, 'props.videoNotes.length');

    const showNotes =
      (contentTypeSwitchers.text && _.get(this, 'props.textNotes.length')) ||
      (contentTypeSwitchers.video && _.get(this, 'props.videoNotes.length'));

    let notesBtnTooltipTitle;

    if (isNotesShown) {
      notesBtnTooltipTitle = <FormattedMessage {...messages.hideNotesTitle} />;
    } else if (noNotesYet) {
      notesBtnTooltipTitle = (
        <FormattedMessage {...messages.thereIsNoNotesYet} />
      );
    } else {
      notesBtnTooltipTitle = <FormattedMessage {...messages.showNotesTitle} />;
    }

    const nextButtonDesktop =
      nextItem && (lesson.isCompleted || completed || !isLoggedIn(auth)) ? (
        <span className={classNames(s.tabletFullWidth, s.goToButtonWrapper)}>
          <Tooltip
            title={formatMessage(messages.nextBtnTooltip, {
              name: _.get(nextItem, 'item.name', ''),
            })}
          >
            <Button
              aria-label={formatMessage(messages.nextBtnTooltip, {
                name: _.get(nextItem, 'item.name', ''),
              })}
              variant="contained"
              color="primary"
              to={`/courses/${course.slug}/${nextUrl}`}
              size="large"
              data-test="next-btn"
              className={classNames(s.tabletFullWidth, s.goToButton)}
              classes={{
                label: s.goToLabel,
              }}
              component={Link}
            >
              <FormattedMessage {...messages.nextBtnLabel} />
              <NextIcon />
            </Button>
          </Tooltip>
        </span>
      ) : null;

    const nextButtonMobile =
      nextItem && (lesson.isCompleted || completed || !isLoggedIn(auth)) ? (
        <div
          className={classNames(
            s.actionButtonWrapper,
            s.tabletFullWidth,
            s.goToButton,
          )}
        >
          <Tooltip
            title={formatMessage(messages.nextBtnTooltip, {
              name: _.get(nextItem, 'item.name', ''),
            })}
          >
            <Button
              variant="contained"
              color="primary"
              to={`/courses/${course.slug}/${nextUrl}`}
              size="large"
              classes={{
                label: s.goToLabel,
              }}
              className={s.tabletFullWidth}
              component={Link}
            >
              <FormattedMessage {...messages.nextBtnLabel} />
              <NextIcon />
            </Button>
          </Tooltip>
        </div>
      ) : null;

    const renderActionButtons = className => (
      <div className={className}>
        {isLoggedIn(auth) && showNotes ? (
          <Tooltip title={notesBtnTooltipTitle}>
            <Button
              variant="contained"
              size="large"
              className={classNames(
                s.actionButtonWrapper,
                s.flexInline,
                s.notesBtn,
                noNotesYet ? s.withPointerEvents : undefined,
              )}
              onClick={noNotesYet ? null : this.toggleNotes}
              disabled={noNotesYet}
              component="div"
            >
              {!isNotesShown && <SpeakerNotesOff className={s.buttonIcon} />}
              {isNotesShown && <SpeakerNotes className={s.buttonIcon} />}
              <FormattedMessage {...messages.notesBtnTitle} />
            </Button>
          </Tooltip>
        ) : null}
        {course._id && isLoggedIn(auth) && (
          <div className={classNames(s.actionButtonWrapper, s.statusBtn)}>
            <Button
              variant="contained"
              color="primary"
              data-tour="complete-lesson-mobile"
              className={classNames(s.tabletFullWidth, {
                [s.completeButtonSuccess]: completed || lesson.isCompleted,
              })}
              onClick={
                completed || lesson.isCompleted
                  ? () => this.toggleLessonReviewContent(true)
                  : this.completeOnce
              }
              size="large"
            >
              {(lesson.isCompleted || completed) && (
                <DoneIcon className={s.buttonIcon} />
              )}
              {completed || lesson.isCompleted ? (
                <FormattedMessage {...messages.completedBtnMsg} />
              ) : (
                ''
              )}
              {!lesson.isCompleted && !completed ? (
                <FormattedMessage {...messages.completeBtnmsg} />
              ) : (
                ''
              )}
            </Button>
          </div>
        )}
        {nextButtonMobile}
      </div>
    );

    return (
      <div className={s.root}>
        <LoadingBar className={s.loadingBar} />
        {isLoggedIn(auth) && (
          <SkillEvaluationModal
            isOpen={isEvaluationModalOpened}
            onSave={this.closeEvaluationModal}
            courseId={course._id}
          />
        )}
        {showLessonReviewModal && (
          <LessonReviewModal
            closeLessonReviewContent={() =>
              this.toggleLessonReviewContent(false)
            }
          />
        )}
        <div
          className={classNames(
            s.appFrame,
            videoFullPage ? s.fullPage : undefined,
          )}
        >
          {(!!_.get(lesson, 'videos.length') ||
            !!totalTranscodingJobs ||
            lesson.youtubeVideoUrl) &&
          videoFullPage &&
          contentTypeSwitchers.video ? null : (
            <LessonHeader
              switchContentType={this.switchContentType}
              contentTypeSwitchers={contentTypeSwitchers}
              isTextContentSwitcherDisabled={isTextContentSwitcherDisabled}
            />
          )}
          <main
            className={classNames(
              s.content,
              videoFullPage ? s.fullPage : undefined,
            )}
          >
            <div className={s.lessonVideoAndTextContent}>
              {contentTypeSwitchers.video &&
                (!!_.get(lesson, 'videos.length') ||
                  totalTranscodingJobs ||
                  lesson.youtubeVideoUrl) && (
                  <Video
                    // key={lesson._id}
                    complete={this.completeOnce}
                    videoFullPage={videoFullPage}
                    videoStop={isEvaluationModalOpened || showLessonReviewModal}
                    handleChangeVideoFullPage={this.handleChangeVideoFullPage}
                    contentTypeSwitchers={contentTypeSwitchers}
                    nextUrl={nextUrl}
                    nextItem={nextItem}
                    query={query}
                    playFrom={playFrom}
                    thumbnailVimeoImg={posterVimeo}
                    ref={ref => {
                      this.player = ref && ref.player;
                      this.updateVideoNotes = ref && ref.toggleNotes;
                    }}
                    className={s.video}
                    isLessonReviewFocused={showLessonReviewModal}
                    key={`video-${lesson._id}`}
                  />
                )}
              {contentTypeSwitchers.text && (
                <Text
                  key={`text-${lesson._id}`}
                  complete={this.completeOnce}
                  contentTypeSwitchers={contentTypeSwitchers}
                  ref={ref => {
                    this.updateTextNotes = ref && ref.toggleNotes;
                  }}
                  className={s.text}
                />
              )}
              {renderActionButtons(
                classNames(
                  s.mobileTabletButtonsContainer,
                  s.visibleOnlyMobileLandscape,
                ),
              )}
            </div>
            {contentTypeSwitchers.audio && !!_.get(lesson, 'audios.length') && (
              <Audio
                key={`audio2-${lesson._id}`}
                complete={this.completeOnce}
                play={
                  !showLessonReviewModal &&
                  !isAudioEnded &&
                  !isCongratulationsModalOpened &&
                  !isEvaluationModalOpened
                }
                setAudioEnded={this.setAudioEnded}
              />
            )}
            <div
              className={classNames(
                s.mobileTabletButtonsContainer,
                s.notVisibleInMobileLandscape,
              )}
            >
              {isLoggedIn(auth) && course._id && showNotes ? (
                <Tooltip title={notesBtnTooltipTitle}>
                  <Button
                    variant="contained"
                    size="large"
                    className={classNames(
                      s.actionButtonWrapper,
                      s.flexInline,
                      s.notesBtn,
                      noNotesYet ? s.withPointerEvents : undefined,
                    )}
                    onClick={noNotesYet ? null : this.toggleNotes}
                    disabled={
                      noNotesYet || updatingTextNotes || loadingTextNotes
                    }
                    component="div"
                  >
                    {!isNotesShown && (
                      <SpeakerNotesOff className={s.buttonIcon} />
                    )}
                    {isNotesShown && <SpeakerNotes className={s.buttonIcon} />}
                    <FormattedMessage {...messages.notesBtnTitle} />
                  </Button>
                </Tooltip>
              ) : null}
              {isLoggedIn(auth) && course._id && (
                <Button
                  variant="contained"
                  color="primary"
                  data-tour="complete-lesson"
                  className={classNames(
                    s.tabletFullWidth,
                    s.actionButtonWrapper,
                    s.statusBtn,
                    {
                      [s.completeButtonSuccess]:
                        completed || lesson.isCompleted,
                    },
                  )}
                  onClick={
                    completed || lesson.isCompleted
                      ? () => this.toggleLessonReviewContent(true)
                      : this.completeOnce
                  }
                  size="large"
                >
                  {(lesson.isCompleted || completed) && (
                    <DoneIcon className={s.buttonIcon} />
                  )}
                  {completed || lesson.isCompleted ? (
                    <FormattedMessage {...messages.completedBtnMsg} />
                  ) : (
                    ''
                  )}
                  {!lesson.isCompleted && !completed ? (
                    <FormattedMessage {...messages.completeBtnmsg} />
                  ) : (
                    ''
                  )}
                </Button>
              )}
              {nextButtonDesktop}
            </div>
          </main>
        </div>
        {course._id && (
          <Modal
            open={isCongratulationsModalOpened}
            onClose={this.closeCongratulationsModal}
          >
            <CongratulationsModal
              onClose={this.closeCongratulationsModal}
              course={course}
              hideCertificateBtn={
                hasMedicalLicense(auth.user && auth.user.mainGroup) ||
                !course.assignCertificate ||
                isTrial(auth)
              }
            />
          </Modal>
        )}
        <Snackbar
          open={!!errorSnackbarMsg}
          onClose={this.handleCloseErrorSnackbar}
          autoHideDuration={2000}
          message={errorSnackbarMsg}
        />
      </div>
    );
  }
}
